import React from 'react';
import PropTypes from 'prop-types';
import { groupImagesByScreenSize } from '../../../../utils/Utils';
import { withCssModulesClassNames } from '../../common/nextMigrationHelpers';

import { default as styles } from '../../scss/components/AssetsByScreenSize.module.scss';
import { Asset } from './header/header.types';

const withCssModulesClassNamesHandler = withCssModulesClassNames(styles);

/**
 * AssetsByScreenSize groups the images on a component by the screenSize property;
 * if there are more than one screen size, then a class is applied to the wrapper to
 * hide or show the asset at the appropriate screen sizes.
 */
interface AssetsByScreenSizeProps {
  assets: Asset[];
  hero: boolean;
  multiGroupWrapperClassName: string;
  renderMultiGroup?(group: Asset[], hero: boolean): React.ReactNode;
  singleGroupWrapperClassName: string;
  renderSingleGroup(group: Asset, hero: boolean): React.ReactNode;
}

function AssetsByScreenSize({
  assets, hero, multiGroupWrapperClassName, renderMultiGroup, singleGroupWrapperClassName, renderSingleGroup,
} : AssetsByScreenSizeProps) {
  const {
    assetsByScreenSize,
    screenSizes,
  } = groupImagesByScreenSize(assets, true);

  return (
    <>
      {
        screenSizes.map((screenSize, idx) => {
          const group = assetsByScreenSize[screenSize];
          const parsedScreenSize = ['undefined', 'null'].includes(screenSize)
            ? 'desktop'
            : screenSize.toLowerCase();

          return group.length > 1 && renderMultiGroup ? (
            <div
              key={group.map(({ fileName }) => `${fileName}-${idx}`).join('-')}
              className={withCssModulesClassNamesHandler(
                multiGroupWrapperClassName,
                'assets-by-sceen-size',
                screenSizes.length > 1 && `assets-by-screen-size--${parsedScreenSize}`,
              )}
            >
              {renderMultiGroup(group, hero)}
            </div>
          ) : (
            <div
              key={group[0].fileName}
              className={withCssModulesClassNamesHandler(
                singleGroupWrapperClassName,
                'assets-by-screen-size',
                screenSizes.length > 1 && `assets-by-screen-size--${parsedScreenSize}`,
              )}
            >
              {renderSingleGroup(group[0], hero)}
            </div>
          );
        })
      }
    </>
  );
}

AssetsByScreenSize.defaultProps = {
  hero: false,
  renderMultiGroup: () => null,
  renderSingleGroup: () => null,
  multiGroupWrapperClassName: '',
  singleGroupWrapperClassName: '',
};

AssetsByScreenSize.propTypes = {
  assets: PropTypes.arrayOf(PropTypes.shape({
    handle: PropTypes.string,
  })).isRequired,
  hero: PropTypes.bool,
  multiGroupWrapperClassName: PropTypes.string,
  renderMultiGroup: PropTypes.func,
  singleGroupWrapperClassName: PropTypes.string,
  renderSingleGroup: PropTypes.func.isRequired,
};

export default AssetsByScreenSize;
